export default function aFilterDuplicates<T>(array: T[]): T[] {
    const seen = new Set()
    return array.filter((item) => {
        const duplicate = seen.has(item)
        seen.add(item)
        return !duplicate
    })
}